import DealCatalog from './components/dealCatalog/';
import DealAnalysis from './components/dealAnalysis/';
import dealCreate from './components/dealCreate/';
import Documentation from './components/Documentation';
import BondAnalysis from './components/bondAnalysis/';
import Acis from './components/acis/';
import Cirt from './components/cirt/';
import Vectors from './components/vectors/';
import ErrorPage from './components/ErrorPage';
import Admin from './components/admin/';
import AdminReports from './components/adminReports/';
import AdminAdco from './components/adminAdco/';
import Portfolio from './components/portfolio';
import VendorGrid from './components/vendorGrid';
import UserCashflows from './components/userCashflows';
import Scenarios from './components/scenario';
import PasswordReset from './components/passwordReset';
import PasswordForgot from './components/passwordForgot';
import Settings from './components/settings';
import Reports from './components/reports';
import CollateralReports from './components/collateralReports';
import LandingRegister from './components/LandingRegister';
import Landing from './components/Landing';
import AboutCRTHub from './components/homePageComponents/AboutCRTHub';
import MoreInformation from './components/homePageComponents/MoreInformation';

export const routes = [
  {
    path: '/',
    component: Landing
  },
  {
    path: '/more_information',
    component: MoreInformation
  },
  {
    path: '/about_crt_hub',
    component: AboutCRTHub
  },
  {
    path: '/trial',
    component: LandingRegister,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/deal_create',
    component: dealCreate,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/deal_catalog',
    component: DealCatalog,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/deal_analysis',
    component: DealAnalysis,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/bond_analysis',
    component: BondAnalysis,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/acis_analysis',
    component: Acis,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cirt_analysis',
    component: Cirt,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/loans',
    component: CollateralReports,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/vector_list',
    component: Vectors,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/scenario_list',
    component: Scenarios,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reports',
    component: Reports,
    meta: {
      requiresAuth: true,
      requiresAnyOfRoles: ['Reports_Consumer', 'Admin']
    }
  },
  {
    path: '/docs',
    component: Documentation,
    meta: {
      requiresAuth: true,
      requiresDocs: true
    }
  },
  {
    path: '/admin',
    component: Admin,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/admin_reports',
    component: AdminReports,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/admin_adco',
    component: AdminAdco,
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/portfolio',
    component: Portfolio,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/vendor_grid',
    component: VendorGrid,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cashflows',
    component: UserCashflows,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    component: Settings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/password_forgot',
    component: PasswordForgot,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/password_reset/:userId',
    component: PasswordReset,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "*",
    component: ErrorPage,
    meta: {
      requiresAuth: true
    }
  }
]
